export class MultiSortView {
    first: SortView;
    second: SortView;
    third: SortView;
    
    firstLevelDisplay: string;
    secondLevelTooltipDisplay: string;
    thirdLevelTooltipDisplay: string;
  
    constructor(first: SortView, second: SortView, third: SortView) {
      this.first = first;
      this.second = second;
      this.third = third;
  
      this.firstLevelDisplay = `Sort By ${this.first.displayName}`;
      this.secondLevelTooltipDisplay = `Then By ${this.second.displayName}`;
      this.thirdLevelTooltipDisplay = `Then By ${this.second.displayName}, ${this.third.displayName}`;
    }
  }
  

export class SortView {
    fieldId: string;
    direction: 'ASC' | 'DESC';
    displayName: string;
  
    constructor(fieldId: string, direction: 'ASC' | 'DESC', displayName: string) {
      this.fieldId = fieldId;
      this.direction = direction;
      this.displayName = displayName;
    }
  }
